module.exports = __webpack_public_path__ + "img/ixtlahuaca.cfd1dd04.jpg";